import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

/**
 * Full worldwide country list for filters / forms (ISO 3166-1 alpha-2).
 * @returns {{ value: string, label: string }[]}
 */
export function getWorldCountryOptions() {
  const names = countries.getNames("en", { select: "official" });
  return Object.entries(names)
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

export function getCountryLabel(iso2) {
  if (!iso2) return "";
  return countries.getName(String(iso2).toUpperCase(), "en") || String(iso2);
}
